__turbopack_context__.v({
  "AllCategoriesSection": "AllCategoriesSection-module__J7QU2W__AllCategoriesSection",
  "CategoryCard": "AllCategoriesSection-module__J7QU2W__CategoryCard",
  "bottom": "AllCategoriesSection-module__J7QU2W__bottom",
  "categories": "AllCategoriesSection-module__J7QU2W__categories",
  "title": "AllCategoriesSection-module__J7QU2W__title",
  "top": "AllCategoriesSection-module__J7QU2W__top",
});
